var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarkTheWord = function SvgMarkTheWord(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4488 14.5511L14.6666 21.3333L11.3333 22L11.9999 18.6667L18.7821 11.8844C19.1346 11.5314 19.613 11.333 20.1119 11.333C20.6108 11.333 21.0892 11.5314 21.4417 11.8844L21.4488 11.8915C21.8019 12.244 22.0002 12.7224 22.0002 13.2213C22.0002 13.7202 21.8019 14.1986 21.4488 14.5511Z",
    fill: "#DAD8FF",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H13.5",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11H13.5",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H9.5",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.3333H3.33333C2.59695 19.3333 2 18.7364 2 18V3.33333C2 2.59695 2.59695 2 3.33333 2H12.7813C13.1347 2.00008 13.4736 2.14043 13.7236 2.39022L16.2764 4.94311C16.5262 5.19307 16.6666 5.53196 16.6667 5.88533V8.66667",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarkTheWord);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS40NDg4IDE0LjU1MTFMMTQuNjY2NiAyMS4zMzMzTDExLjMzMzMgMjJMMTEuOTk5OSAxOC42NjY3TDE4Ljc4MjEgMTEuODg0NEMxOS4xMzQ2IDExLjUzMTQgMTkuNjEzIDExLjMzMyAyMC4xMTE5IDExLjMzM0MyMC42MTA4IDExLjMzMyAyMS4wODkyIDExLjUzMTQgMjEuNDQxNyAxMS44ODQ0TDIxLjQ0ODggMTEuODkxNUMyMS44MDE5IDEyLjI0NCAyMi4wMDAyIDEyLjcyMjQgMjIuMDAwMiAxMy4yMjEzQzIyLjAwMDIgMTMuNzIwMiAyMS44MDE5IDE0LjE5ODYgMjEuNDQ4OCAxNC41NTExWiIgZmlsbD0iI0RBRDhGRiIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01IDdIMTMuNSIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01IDExSDEzLjUiIHN0cm9rZT0iIzQyMzlGQiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNSAxNUg5LjUiIHN0cm9rZT0iIzQyMzlGQiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOCAxOS4zMzMzSDMuMzMzMzNDMi41OTY5NSAxOS4zMzMzIDIgMTguNzM2NCAyIDE4VjMuMzMzMzNDMiAyLjU5Njk1IDIuNTk2OTUgMiAzLjMzMzMzIDJIMTIuNzgxM0MxMy4xMzQ3IDIuMDAwMDggMTMuNDczNiAyLjE0MDQzIDEzLjcyMzYgMi4zOTAyMkwxNi4yNzY0IDQuOTQzMTFDMTYuNTI2MiA1LjE5MzA3IDE2LjY2NjYgNS41MzE5NiAxNi42NjY3IDUuODg1MzNWOC42NjY2NyIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";